import React, { useLayoutEffect } from 'react';
import { FAQ_SECTIONS } from '../utils/faqData';
import ScrollToTopButton from './common/ScrollToTopButton';

const FAQPage = () => {
  // Force scroll to top on mount - useLayoutEffect runs synchronously before paint
  useLayoutEffect(() => {
    window.scrollTo(0, 0);
    document.documentElement.scrollTop = 0;
    document.body.scrollTop = 0;
  }, []);

  return (
    <div 
      data-public-scroll-container="true"
      className="min-h-screen bg-gray-50 py-8 px-4 sm:px-6"
      style={{ 
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        overflowY: 'auto',
        overflowX: 'hidden'
      }}
    >
      <div className="max-w-4xl mx-auto">
        {/* Premium Legal Header */}
        <header className="flex flex-col sm:flex-row sm:items-center sm:justify-between border-b border-gray-200 pb-4 mb-8 gap-4">
          <div className="flex items-center gap-3">
            <img src="/new_icon+text_color.png" alt="CraftMyParty" className="h-12 sm:h-14 w-auto" />
            <div className="h-6 w-px bg-gray-200 hidden sm:block"></div>
            <span className="hidden sm:inline-block text-xs font-semibold text-gray-400 uppercase tracking-wider">Your Party, Made Personal.</span>
          </div>
          <nav className="flex items-center gap-6 text-sm font-bold">
            <a href="/home" className="text-gray-600 hover:text-purple-600 transition">Home</a>
            <a href="/privacy" className="text-gray-600 hover:text-purple-600 transition">Privacy</a>
            <a href="/terms" className="text-gray-600 hover:text-purple-600 transition">Terms</a>
            <a href="/faq" className="text-purple-600 border-b-2 border-purple-600 pb-0.5 transition">FAQ</a>
          </nav>
        </header>

        <div className="mb-8">
          <h1 className="text-3xl sm:text-4xl font-bold text-gray-900 mb-2">Frequently Asked Questions</h1>
          <p className="text-gray-600">Quick answers for planning decisions, credits, billing, and account questions.</p>
        </div>

        {/* Content */}
        <div className="space-y-6">
          {FAQ_SECTIONS.map((section) => (
            <section key={section.title} className="rounded-2xl border border-gray-200 bg-white p-6 shadow-sm">
              <h2 className="text-xl font-extrabold text-gray-950 mb-4">{section.title}</h2>
              <div className="space-y-3">
                {section.items.map((faq) => (
                  <details key={faq.q} className="rounded-xl border border-gray-100 bg-gray-50 p-4 transition-all duration-200 group">
                    <summary className="cursor-pointer text-sm font-bold text-gray-950 list-none flex items-center justify-between">
                      <span>{faq.q}</span>
                      <span className="text-gray-400 group-open:rotate-180 transition-transform duration-200">
                        <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2.5} d="M19 9l-7 7-7-7" />
                        </svg>
                      </span>
                    </summary>
                    <p className="mt-3 text-sm leading-relaxed text-gray-600 border-t border-gray-200/60 pt-3">{faq.a}</p>
                  </details>
                ))}
              </div>
            </section>
          ))}
        </div>
      </div>
      <ScrollToTopButton targetSelector="[data-public-scroll-container='true']" />
    </div>
  );
};

export default FAQPage;
